import React, { useRef, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import { colors } from '../../../../theme/color-palette';
import { tooltip } from './utils';

const useStyles = makeStyles(() => ({
	barChart: {
		paddingLeft: '0px',
		marginLeft: 0,
		height: '250px',
		paddingTop: '18px',
	},
}));

am4core.options.commercialLicense = true;

const BarChart = (props) => {
	const { chartData } = props;
	const chartRef = useRef(null);
	const classes = useStyles();

	function createSeries(field, color, chart) {
		let series = chart.series.push(new am4charts.ColumnSeries());
		series.dataFields.valueX = field;
		series.dataFields.categoryY = 'labelName';
		series.columns.template.height = am4core.percent(100);
		series.columns.template.width = am4core.percent(100);
		series.sequencedInterpolation = true;
		series.fill = am4core.color(color);
		series.columns.template.maxWidth = 10;
		series.strokeWidth = 0;
		series.columns.template.tooltipHTML = tooltip(field);
		series.tooltip.pointerOrientation = 'down';
		series.tooltip.getFillFromObject = false;
		series.tooltip.background.fill = am4core.color(colors.OFF_WHITE);
		series.tooltip.background.cornerRadius = 4;
		series.columns.template.cursorOverStyle = am4core.MouseCursorStyle.pointer;
	}

	useLayoutEffect(() => {
		am4core.useTheme(am4themes_animated);

		let chart = am4core.create('barChart', am4charts.XYChart);
		chart.data = chartData;

		chart.focusFilter = undefined;
		let categoryAxis = chart.yAxes.push(new am4charts.CategoryAxis());
		categoryAxis.dataFields.category = 'labelName';
		categoryAxis.numberFormatter.numberFormat = '#';
		categoryAxis.renderer.inversed = true;
		categoryAxis.renderer.grid.template.location = 0;
		categoryAxis.renderer.cellStartLocation = 0.2;
		categoryAxis.renderer.cellEndLocation = 0.8;
		categoryAxis.renderer.labels.template.disabled = true;
		categoryAxis.renderer.grid.template.strokeWidth = 0;

		let valueAxis = chart.xAxes.push(new am4charts.ValueAxis());
		valueAxis.renderer.labels.template.disabled = true;
		valueAxis.renderer.grid.template.strokeWidth = 0;
		valueAxis.renderer.opposite = true;
		valueAxis.min = 0;

		createSeries('tyValue', colors.PURPLE_ACTIVE, chart);
		createSeries('lyValue', colors.PURPLE_GRAY, chart);

		chartRef.current = chart;
		return () => {
			chart.dispose();
		};
	}, [chartData]);

	return <Box id={'barChart'} className={classes.barChart}></Box>;
};

BarChart.propTypes = {
	chartData: PropTypes.arrayOf(PropTypes.shape({})),
};

export default BarChart;
